import { AppConfigService } from 'src/app/appConfig.service';
import { AnalyticsIdentity } from './analytics-identity';
import { SupportChat } from './support-chat';

/**
 * The app's support chat and the user's analytics identity. The chat is Intercom, or the
 * website's chat when the backend switches it on (SupportChat, supportChat: "synced"): every
 * method here goes to whichever is on, so its callers (the sidebar's Support item, the error
 * toasts, login, signup and each page's identify call) need not know which.
 */
export class ManageIntercom {
  constructor(configService: AppConfigService) {
  }

  /**
   * Call after login/signup or org switch to identify the user to the support chat and PostHog.
   * Reads all needed values from localStorage.
   */
  public static identifyUser(launcher: boolean = true, configService: AppConfigService): void {
    const userId = localStorage.getItem('Id');
    if (!userId) return;

    AnalyticsIdentity.identify();

    SupportChat.configure(configService);
    if (SupportChat.isSynced) {
      SupportChat.mount();
      return;
    }

    const createdAtRaw = localStorage.getItem('CreatedAt');
    const createdAt = createdAtRaw
      ? Math.floor(new Date(createdAtRaw).getTime() / 1000)
      : Math.floor(Date.now() / 1000);

    const userName = localStorage.getItem('UserName');
    const email = localStorage.getItem('Email');
    const orgId = localStorage.getItem('SelectedOrganization');
    const orgName = localStorage.getItem('SelectedOrganizationName');

    const settings: any = {
      api_base: 'https://api-iam.intercom.io',
      app_id: configService.intercomAppId,
      user_id: userId,
      email: email,
      name: userName,
      created_at: createdAt,
      hide_default_launcher: launcher,
    };

    if (orgId) {
      settings.company = {
        company_id: orgId,
        name: orgName || orgId,
      };
    }

    window.intercomSettings = settings;
    if (window.Intercom) {
      window.Intercom('boot', settings);
    }
  }

  public static updateintercode(launcher: boolean = true, configService: AppConfigService): void {
    ManageIntercom.identifyUser(launcher, configService);
  }

  static show() {
    if (SupportChat.isSynced) SupportChat.show();
    else window.Intercom?.('show');
  }

  static hide() {
    if (SupportChat.isSynced) SupportChat.hide();
    else window.Intercom?.('hide');
  }

  static shutdown() {
    SupportChat.unmount();
    window.Intercom?.('shutdown');
  }

  public static boot(data: any) {
    if (!window.Intercom) return;
    window.Intercom('boot', data);
  }
}
